import Appsignal from "@appsignal/javascript";

const url = process.env.REACT_APP_BACKEND_URL || "";
const namespace = (url.includes("localhost") || url.includes("preview")) ? "preview" : "production";

const appsignal = new Appsignal({
  key: namespace === "preview" ? "bd4ae82c-dffa-46e3-85cf-2b5f12a9199d" : "ddffeba7-a63b-4960-a3dc-435c5f7bc423",
  namespace,
});

export default appsignal;
